import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from '../common';
import AWSPortOpeningRequest from '../../models/entities/AWSPortOpeningRequests';
import moment from 'moment';
import ProgressBarSmall from './components/ProgressBarSmall';
import '../common/CommonElements.css';

interface AWSPortOpeningRequestsHomeTableRowProps {
	request: AWSPortOpeningRequest;
}

const AWSPortOpeningRequestsHomeTableRow = (props: AWSPortOpeningRequestsHomeTableRowProps) => {
	const navigate = useNavigate();

	const goToPORDetails = () => {
		navigate(`/accounts/${props.request.accountId}/awsPortOpeningRequests/${props.request.id}`);
	};
	
	return (
		<Table.Row className='request-row' onClick={goToPORDetails} style={{cursor: 'pointer'}}>
			<Table.Cell className='em-u-text-align-center'>
				{props.request.id}
			</Table.Cell>
			<Table.Cell className='em-u-text-align-center'>
				{props.request?.type?.name}
			</Table.Cell>
			<Table.Cell className='em-u-text-align-center'>
				{props.request.direction.displayName}
			</Table.Cell>
			<Table.Cell className='em-u-text-align-center'>
				{props.request.workflowInstance.createdBy.displayName}
			</Table.Cell>
			<Table.Cell className="em-u-text-align-center">
				{props.request.contactUser?.displayName}
			</Table.Cell>
			<Table.Cell className="em-u-text-align-center">
				{props.request.approvingUser?.displayName || props.request.appEndorser?.displayName}
			</Table.Cell>
			<Table.Cell className="em-u-text-align-center">
				{moment(new Date(props.request.workflowInstance.createdDate)).format('YYYY-MM-DD')}
			</Table.Cell>
			<Table.Cell className="em-u-text-align-center">
				<ProgressBarSmall
					workflowState={props.request.workflowInstance.currentWorkflowInstanceState.workflowState}
					porScope={props.request.direction?.name}
					workflowStates={props.request.workflowInstance.workflowInstanceStates}
				/>
			</Table.Cell>
		</Table.Row>
	);
};

export default AWSPortOpeningRequestsHomeTableRow;
